import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";

export function LoadingSpinner({ className }: { className?: string }) {
  return (
    <div className={cn("animate-spin", className)}>
      <Loader2 />
    </div>
  );
}
